import React from 'react';
import { Alert } from '@mui/material';

import type { IntakeStatusBaseSteps } from '@shared/patient-intake-status';

import { SingleDocumentListItem } from '../../../../../../components/DocumentManager';
import { usePatientIntakeStatusContext } from '../../../hooks';

type GenerateConsentToReleaseHealthSummaryViewerProps = {
  step: IntakeStatusBaseSteps['GENERATE_CONSENT_TO_RELEASE_HEALTH_SUMMARY'];
};

export const GenerateConsentToReleaseHealthSummaryViewer: React.FC<
  GenerateConsentToReleaseHealthSummaryViewerProps
> = ({ step }) => {
  const { patientId } = usePatientIntakeStatusContext();

  const { status, metadata } = step.currentStatus;

  if (!status || status === 'NOT_STARTED' || status === 'ERROR' || !metadata) {
    return null;
  }

  const fileUploadDocId = metadata.fileUploadDocId;

  if (!fileUploadDocId) {
    return <Alert severity="info">No document has been uploaded for this step yet.</Alert>;
  }

  return <SingleDocumentListItem documentId={fileUploadDocId} patientId={patientId} type="PATIENT_DOCUMENT_UPLOAD" />;
};
